<div class="top-content" [class.follow-grid]="isEpic" [class.hide]="hidePanel">
  <div class="btn-group" dropdown container="body">

      <ng-select [items]="jobList"
        class="dropdown-quicklink arrow-down no-outline no-border"
        [clearable]="false"
        [searchable]="false"
        bindLabel="JobName"
        bindValue="JobValue"
        placeholder="Quick Links">

        <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
          <div class="job-image-container" (click)="triggerJob(item.JobId)">
            <ng-container *ngIf="availableImages.indexOf(item.JobDisplay) > -1; else template">
              <img #image width="20px" height="20px" [src]="!item.IsHover ? '../../assets/images/' + item.JobDisplay + 'GREY.png' : '../../assets/images/' + item.JobDisplay + 'WHITE.png'">
            </ng-container>
            <ng-template #template>
              <img #image width="20px" height="20px" [src]="!item.IsHover ? '../../assets/images/TEMPLATEGREY.png' : '../../assets/images/TEMPLATEWHITE.png'">
            </ng-template>
            <p class="job-display">{{item.JobName}}</p>
          </div>
        </ng-template>
      </ng-select>
  </div>
</div>